import React from "react";

type DetailRow = { label: string; value: string };

type JobcardManpowerDetailsPanelProps = {
  rows: DetailRow[];
  loading?: boolean;
};

export const JobcardManpowerDetailsPanel: React.FC<
  JobcardManpowerDetailsPanelProps
> = ({ rows, loading }) => {
  const jobNo = rows.find((r) => r.label === "Jobcard No.")?.value ?? "—";
  const vehicle =
    [
      rows.find((r) => r.label === "Vehicle make")?.value,
      rows.find((r) => r.label === "Model")?.value,
    ]
      .filter((v) => v && v !== "—")
      .join(" ") || "—";
  const customer = rows.find((r) => r.label === "Customer")?.value ?? "—";

  return (
    <section
      className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/80 dark:bg-gray-800/50 overflow-hidden"
      aria-label="Job card details"
    >
      <div className="px-4 py-2.5 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
        <p className="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          Job card details
        </p>
        <p className="text-base font-semibold text-gray-900 dark:text-gray-100 mt-0.5">
          {loading ? "Loading…" : jobNo}
          {!loading && vehicle !== "—" ? (
            <span className="font-normal text-gray-600 dark:text-gray-300">
              {" "}
              · {vehicle}
            </span>
          ) : null}
        </p>
        {!loading && customer !== "—" ? (
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-0.5">
            {customer}
          </p>
        ) : null}
      </div>

      <div className="p-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2.5 text-sm">
        {rows.map(({ label, value }) => (
          <div key={label} className="min-w-0">
            <dt className="text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
              {label}
            </dt>
            <dd className="text-gray-900 dark:text-gray-100 mt-0.5 break-words">
              {loading && value === "—" ? (
                <span className="text-gray-400">…</span>
              ) : (
                value
              )}
            </dd>
          </div>
        ))}
      </div>
    </section>
  );
};
